export default "__VITE_ASSET__XAzVh71y__"